import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { createCliente, APP_OPTIONS } from '../../services/clienteService.ts';
import { resolveOrgId } from '../../services/organizationService.ts';
import { useAuth } from '../../context/AuthContext.tsx';
import CheckboxCardGroup from '../../components/ui/CheckboxCardGroup.tsx';

export default function RegisterCustomer() {
    const { user, orgActual } = useAuth();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [apps, setApps] = useState([]);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const clienteId = await createCliente({ name, email, apps, orgId: resolveOrgId(orgActual, user.uid) });

            toast.success("Cliente registrado exitosamente!");
            setName('');
            setEmail('');
            setApps([]);

            // Redirige a crear el proyecto de este cliente después de 2 segundos
            setTimeout(() => navigate(`/proyectos/nuevo?clienteId=${clienteId}`), 2000);
        } catch (err) {
            console.error('❌ Error al registrar cliente:', err);
            toast.error("❌ Error al registrar el cliente");
        }
    };

    return (
        <div className="p-6 max-w-md mx-auto bg-gray-800 rounded-xl text-white shadow mt-10">
            <h2 className="text-xl font-bold mb-4">Registrar Nuevo Cliente</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1.5">
                        Nombre del cliente
                    </label>
                    <input
                        className="w-full p-2 rounded bg-gray-700"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1.5">
                        Email de contacto
                    </label>
                    <input
                        className="w-full p-2 rounded bg-gray-700"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                {/* Solo aplica a clientes de proyectos SAP Ariba (plan-proyectos-generales, G2): opcional y plegado. */}
                <details className="mb-4" open={apps.length > 0}>
                    <summary className="cursor-pointer text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1.5">
                        Aplicaciones SAP Ariba (opcional)
                    </summary>
                    <p className="text-xs text-gray-500 mb-2">Solo si es un cliente de SAP Ariba.</p>
                    <CheckboxCardGroup options={APP_OPTIONS} selected={apps} onChange={setApps} />
                </details>
                <button
                    type="submit"
                    className="bg-blue-500 hover:bg-blue-600 px-4 py-2 rounded w-full mb-2"
                >
                    Registrar Cliente
                </button>
            </form>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
        </div>
    );
}
